import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../services/dialog.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {

  forgotForm: UntypedFormGroup;
  submitted = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userService : UserService,
    private translate : TranslateService
  ) { }

  ngOnInit() {
    this.forgotForm = this.formBuilder.group({
      email: ['', Validators.required]
    });
  }

  /**
   * Per accedere ai campi del form facilmente
   */
  get f() {
    return this.forgotForm.controls;
  }

  /**
   * Al click del pulsante "Invia Password" invio l'email inserita dall'utente
   * per recuperare la password
   */
  async onSubmit() {
    this.submitted = true;

    // Se il form non è valido mi fermo
    if (this.forgotForm.invalid) {
      return;
    }
    let email = this.forgotForm.value['email'];
    await this.userService.sendResetPasswordByEmail(email).then((res) => {
      if (res.isMyNamirial == 0) {
        DialogService.Success(this.translate.instant("DIALOGS.RESET_PASSWORD"));
      }
      else {
        this.goToNamirialApp();
      }
      
    }).catch(error => {
      DialogService.Error(error.message);
    })

  }

  goToNamirialApp() {
    
    DialogService.Confirm(this.translate.instant("DIALOGS.MYNAMIRIAL_RESET_PASSWORD"), () => {
      window.open("https://auth.namirial.app/realms/namirial/login-actions/reset-credentials", '_blank');
    }, true);

  }

}
